module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/ex-japanese-97c56d4c1a08eec2e33cd411ace0b58a.png";